import {useQuery} from 'react-query';

import getOffers from '.';

interface IOffersProps {
  search?: string;
  selected_cities_id?: string;
  advertisement_type?: string;
  ordering?: string;
  start_price?: number;
  end_price?: number;
  has_special_offer?: boolean;
  input_guid?: string;
}

const useGetOffers = (props: IOffersProps) => {
  const {data, isLoading} = useQuery(['get-offers', props], () =>
    getOffers(props),
  );

  return {amazingOffers: data, amazingOffersIsLoading: isLoading};
};

export default useGetOffers;
